import { useEffect } from 'react';
import { apiFetch, getSessionId } from '../services/api';

export type CognitionEvent = { event_id: string; sequence_number: number; role: string; content: string; origin: string; job_id: string; valid: boolean };
export type CognitionOrder = { event_id: string; source_message_id: string; sequence_number: number; valid: boolean };

export default function CognitionMessages({ accountId, refresh, onEvents }: { accountId: string; refresh: number; onEvents: (rows: CognitionEvent[], ordering: CognitionOrder[]) => void }) {
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    const load = async () => {
      const session = getSessionId();
      if (!session) return;
      try {
        const response = await apiFetch(`/cognition/events?conversation_id=${encodeURIComponent(session)}`, { signal: controller.signal });
        if (!response.ok) return;
        const result = await response.json();
        if (active && session === getSessionId() && result.schema_version === 'lexi.cognition.v1') onEvents(result.events, result.ordering || []);
      } catch { /* Ordinary chat is independent of this optional snapshot. */ }
    };
    void load();
    const timer = window.setInterval(() => { if (document.visibilityState === 'visible') void load(); }, 2000);
    return () => { active = false; controller.abort(); clearInterval(timer); };
  }, [accountId, refresh, onEvents]);
  return null;
}
